import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiLogOut, FiMenu, FiX } from "react-icons/fi";
import { clearAuthSession } from "../../utils/auth";

const navLinks = [
  { label: "Home", path: "/home" },
  { label: "Carrier Access", path: "/carrier-login" },
  { label: "Scripts", path: "/scripts" },
  { label: "Agent Resources", path: "/agent-resources" },
  { label: "Carrier Contacts", path: "/carrier-contacts" },
  { label: "Training", path: "/training" },
];

const AuthNavbar = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileNavOpen(false);
  };

  const handleLogout = () => {
    clearAuthSession();
    setIsMobileNavOpen(false);
    navigate("/login", { replace: true });
  };

  return (
    <nav className="portal-top-nav fixed top-0 w-full z-50">
      <div className="portal-top-nav-inner px-6 mx-auto">
        <div className="portal-top-left">
          <button
            className="portal-top-brand"
            type="button"
            onClick={() => handleNavigation("/home")}
          >
            Agent Portal
          </button>

          <div className="portal-session-badge" aria-hidden="true">
            <span />
            Secure Session
          </div>
        </div>

        <div className="portal-top-links" aria-label="Primary navigation">
          {navLinks.map(({ label, path }) => {
            const isActive = pathname === path;
            return (
              <button
                className={`portal-top-link${isActive ? " active" : ""}`}
                key={path}
                type="button"
                onClick={() => handleNavigation(path)}
              >
                {label}
              </button>
            );
          })}
        </div>

        <div className="portal-top-actions">
          <button
            className="portal-top-logout"
            type="button"
            onClick={handleLogout}
            aria-label="Logout"
          >
            <FiLogOut size={15} />
            Logout
          </button>
        </div>

        <button
          className="portal-top-menu-toggle"
          type="button"
          aria-label={isMobileNavOpen ? "Close page navigation" : "Open page navigation"}
          aria-expanded={isMobileNavOpen}
          onClick={() => setIsMobileNavOpen((open) => !open)}
        >
          {isMobileNavOpen ? <FiX size={18} /> : <FiMenu size={18} />}
        </button>
      </div>

      {isMobileNavOpen && (
        <div className="portal-mobile-nav-panel">
          {navLinks.map(({ label, path }) => {
            const isActive = pathname === path;
            return (
              <button
                key={path}
                className={`portal-mobile-nav-link${isActive ? " active" : ""}`}
                type="button"
                onClick={() => handleNavigation(path)}
              >
                {label}
              </button>
            );
          })}
          <button className="portal-mobile-logout" type="button" onClick={handleLogout}>
            <FiLogOut size={15} />
            Logout
          </button>
        </div>
      )}
    </nav>
  );
};

export default AuthNavbar;
